// Single source of truth for how a recommendation is labelled across the UI.
export const recLabel = (rec) => {
    if (!rec || !rec.action || rec.action === 'WAIT') {
        return { label: 'BEKLE', official: false, weak: false };
    }
    if (rec.official) return { label: `${rec.action} GİR`, official: true, weak: false };
    return { label: `${rec.action} EĞİLİMİ`, official: false, weak: true };
};

export const officialTooltip = (rec) => {
    if (!rec || rec.action === 'WAIT') return 'Net yön yok — işlem yok.';
    if (rec.official) return 'RESMİ SİNYAL: güven ≥%80, R/R ≥2, en az 3 destekleyen sinyal, 4s trend ters değil.';
    const miss = (rec.official_missing || []).join(' · ');
    return `RESMİ DEĞİL — işlem açma, sadece eğilim. Eksik: ${miss || 'kriterler'}`;
};
